<template lang="pug">
.study-result-last-minute-check-list
  //- サイドメニュー部
  side-menu.study-result-last-minute-check-list__side-menu(
    :userRole='userRole',
    :currentLink='currentLink',
    :linkEvent='sideMenuLinkEvent',
    :logoutEvent='logoutEvent'
  )
    template(#separateText)
      slot(name='sideMenuSeparateText')
    template(#logoutText)
      slot(name='logoutText')
  //- コンテンツ表示部
  .study-result-last-minute-check-list__content
    breadcrumb-list.study-result-last-minute-check-list__content__breadcrumb(
      :breadcrumbs='breadcrumbs',
      :moveEvent='breadcrumbMoveEvent'
    )
    //- キャプチャ画像一覧表示
    .study-result-last-minute-check-list__content__body__image-block
      .study-result-last-minute-check-list__content__body__image-block__heading
        tab-heading.study-result-last-minute-check-list__content__body__image-block__heading__tab(:isActive='true')
          slot(name='imageListLabel')
      .study-result-last-minute-check-list__content__body__image-block__main
        .study-result-last-minute-check-list__content__body__image-block__main__images
          study-result-detail-image-list.study-result-last-minute-check-list__content__body__image-block__main__images__list(
            :userRole='userRole',
            :images='images',
            :clickEvent='openImageModal'
          )
    //- 得点情報一覧表示
    .study-result-last-minute-check-list__content__body__table-block
      .study-result-last-minute-check-list__content__body__table-block__heading
        tab-heading.study-result-last-minute-check-list__content__body__table-block__heading__tab(:isActive='true') {{ titleText }}
      .study-result-last-minute-check-list__content__body__table-block__main
        study-result-last-minute-check-table.study-result-last-minute-check-list__content__body__table-block__main__table(
          :studyResultLastMinuteChecks='studyResultLastMinuteChecks',
          :annotationLabel='annotationLabel'
        )
          template(#problemNumberHeader)
            slot(name='problemNumberHeader')
          template(#questionNumberHeader)
            slot(name='questionNumberHeader')
          template(#correctAnswerHeader)
            slot(name='correctAnswerHeader')
          template(#correctSymbolHeader)
            slot(name='correctSymbolHeader')
          template(#previousCorrectSymbolHeader)
            slot(name='previousCorrectSymbolHeader')
          template(#previousTwoCorrectSymbolHeader)
            slot(name='previousTwoCorrectSymbolHeader')
        .study-result-last-minute-check-list__content__body__table-block__main__anotation.text-small
          .study-result-last-minute-check-list__content__body__table-block__main__anotation__label {{ annotationLabel }}
          .study-result-last-minute-check-list__content__body__table-block__main__anotation__text
            slot(name='AnnotationText')
  //- モーダル部
  modal-study-result-image.study-result-detail__modal(
    ref='modalStudyResultImage',
    :title='modalTitle',
    :imageUrl='modalImageUrl'
  )
</template>

<script lang="ts">
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import SideMenu from '@/components/organisms/manager/SideMenu.vue'
import BreadcrumbList from '@/components/organisms/manager/BreadcrumbList.vue'
import TabHeading from '@/components/molecules/manager/TabHeading.vue'
import StudyResultDetailImageList from '@/components/organisms/manager/StudyResultDetailImageList.vue'
import StudyResultLastMinuteCheckTable from '@/components/organisms/manager/StudyResultLastMinuteCheckTable.vue'
import ModalStudyResultImage from '@/components/organisms/manager/ModalStudyResultImage.vue'
import { breadcrumbType } from '@/models/breadcrumbModel'
import { StudyResultDetailImage, StudyResultLastMinuteCheckType } from '@/models/studyResultDetailModel'
import { LinkSetting } from '@/const/SideMenuSettings'
import { UserRoles } from '@/const/UserRoles'
import { CommonCharacterSetting } from '@/const/DisplaySettings'

/**
 * 履歴管理・生徒の成績表直前チェック画面
 */
@Component({
  components: {
    SideMenu,
    BreadcrumbList,
    TabHeading,
    StudyResultDetailImageList,
    StudyResultLastMinuteCheckTable,
    ModalStudyResultImage,
  },
})
export default class StudyResultLastMinuteCheckList extends Vue {
  // ユーザ権限
  @Prop()
  userRole!: UserRoles

  // このページのリンク設定
  @Prop()
  currentLink!: LinkSetting

  // サイドメニューリンク押下時のイベント
  @Prop()
  sideMenuLinkEvent!: Function

  // ログアウトボタン押下時のイベント
  @Prop()
  logoutEvent!: Function

  // パンくず一覧情報
  @Prop()
  breadcrumbs!: breadcrumbType[]

  // パンくず遷移イベント
  @Prop()
  breadcrumbMoveEvent!: Function

  // キャプチャ画像一覧情報
  @Prop()
  images!: StudyResultDetailImage[]

  // 画像一覧クリック時イベント
  @Prop()
  imageListClickEvent!: Function

  // タブに表示するタイトル
  @Prop()
  titleText!: string

  // テスト結果直前チェック詳細表示情報
  @Prop()
  studyResultLastMinuteChecks!: StudyResultLastMinuteCheckType[]

  // モーダルタイトル
  @Prop()
  modalTitle!: string

  // モーダルに表示する画像URL
  @Prop()
  modalImageUrl!: string

  // モーダルref
  @Ref()
  modalStudyResultImage!: ModalStudyResultImage

  // 注釈のラベル記号
  private annotationLabel = CommonCharacterSetting.ANNOTATION_LABEL

  // 画像モーダルを開く
  private async openImageModal(image: StudyResultDetailImage) {
    await this.imageListClickEvent(image)
    if (this.modalImageUrl) {
      this.modalStudyResultImage.show()
    }
  }
}
</script>

<style lang="stylus" scoped>
.study-result-last-minute-check-list
  display flex
  width 100%
  height 100%

  &__content
    width calc(100% - 263px)
    height 100%
    display flex
    flex-direction column
    padding 40px
    gap 10px

    &__body
      display flex
      flex-direction column
      min-height 0
      width 100%

      &__image-block
        height 270px
        &__heading
          display flex
          height 43px
          &__tab
            box-shadow none !important

        &__main
          z-index 1
          width 100%
          display flex
          flex-direction column
          border-radius 0px 15px 15px 15px
          background var(--color-manager-list__background)
          box-shadow 0px 3px 5px 0px var(--color-manager-list__shadow)
          height 220px

          &__images
            width 100%
            display flex
            padding 10px 20px
            height 220px

            &__list
              height 100%
              width 97%
              margin 0 auto

      &__table-block
        flex 1
        display flex
        flex-direction column
        min-height 0

        &__heading
          display flex
          height 43px
          &__tab
            box-shadow none !important

        &__main
          flex 1
          z-index 1
          width 100%
          display flex
          flex-direction column
          border-radius 0px 15px 15px 15px
          background var(--color-manager-list__background)
          box-shadow 0px 3px 5px 0px var(--color-manager-list__shadow)
          overflow-y auto

          &__table
            margin 20px 0 0 0

          &__anotation
            display flex
            align-items center
            padding 20px

            &__label
              margin-right 5px
              color var(--color-manager-list-alert__text)
</style>
